<template>
  <main class="mt-0 main-content">
    <ToastPrime position="bottom-left" />
    <section>
      <div class="page-header min-vh-100">
        <div class="container-fluid px-0">
          <div class="row g-0">
            <div
              class="col-6 d-lg-flex d-none h-100 my-auto ps-0 position-absolute top-0 start-0 text-center justify-content-center flex-column">
              <div
                class="position-relative h-100 m-3 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                :style="{
                  backgroundImage: `url(${apiUrl + '/gambar_login.jpg'})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }">
                <span class="mask bg-gradient-primary opacity-6"></span>
                <div class="position-relative z-index-1">
                  <h4 class="mt-5 text-white font-weight-bolder">
                    "Secure Your Account"
                  </h4>
                  <p class="text-white px-5">
                    Pastikan akun Anda tetap aman dengan memperbarui kata sandi secara berkala melalui sistem manajemen cerdas SmartCat.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 offset-lg-6 d-flex align-items-center justify-content-center min-vh-100">
              <div class="card card-plain login-card shadow-lg bg-white">
                <div class="card-header pb-0 text-start bg-transparent border-0">
                  <h4 class="font-weight-bolder text-primary">Change Password</h4>
                  <p class="mb-0">Your password must be changed before you can continue.</p>
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <div class="position-relative">
                      <input
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="New Password"
                        class="form-control"
                        :class="errorMessage.password ? 'border-danger' : ''"
                        :disabled="onLoading"
                        @keyup.enter="submitChangePassword"
                      />
                      <button
                        type="button"
                        class="btn btn-link position-absolute end-0 top-0"
                        style="z-index: 10;"
                        @click="showPassword = !showPassword"
                      >
                        <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                      </button>
                    </div>
                    <small v-if="errorMessage.password" class="text-danger">{{ errorMessage.password }}</small>
                  </div>
                  <div class="mb-3">
                    <div class="position-relative">
                      <input
                        v-model="confirmPassword"
                        :type="showConfirmPassword ? 'text' : 'password'"
                        placeholder="Confirm New Password"
                        class="form-control"
                        :class="errorMessage.confirmPassword ? 'border-danger' : ''"
                        :disabled="onLoading"
                        @keyup.enter="submitChangePassword"
                      />
                      <button
                        type="button"
                        class="btn btn-link position-absolute end-0 top-0"
                        style="z-index: 10;"
                        @click="showConfirmPassword = !showConfirmPassword"
                      >
                        <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                      </button>
                    </div>
                    <small v-if="errorMessage.confirmPassword" class="text-danger">{{ errorMessage.confirmPassword }}</small>
                  </div>
                  <!-- Password Policy Checklist -->
                  <div v-if="password.length > 0" class="mb-3">
                    <small class="text-muted d-block mb-1">Password requirements:</small>
                    <small :class="policy.minLength ? 'text-success' : 'text-danger'" class="d-block">
                      <i :class="policy.minLength ? 'fas fa-check' : 'fas fa-times'"></i> Min. 8 characters
                    </small>
                    <small :class="policy.hasUppercase ? 'text-success' : 'text-danger'" class="d-block">
                      <i :class="policy.hasUppercase ? 'fas fa-check' : 'fas fa-times'"></i> Uppercase letter (A-Z)
                    </small>
                    <small :class="policy.hasLowercase ? 'text-success' : 'text-danger'" class="d-block">
                      <i :class="policy.hasLowercase ? 'fas fa-check' : 'fas fa-times'"></i> Lowercase letter (a-z)
                    </small>
                    <small :class="policy.hasNumber ? 'text-success' : 'text-danger'" class="d-block">
                      <i :class="policy.hasNumber ? 'fas fa-check' : 'fas fa-times'"></i> Number (0-9)
                    </small>
                    <small :class="policy.hasSymbol ? 'text-success' : 'text-danger'" class="d-block">
                      <i :class="policy.hasSymbol ? 'fas fa-check' : 'fas fa-times'"></i> Symbol (!@#$%^&* etc.)
                    </small>
                  </div>
                  <div class="text-center">
                    <argon-button
class="mt-4" variant="gradient" color="primary" full-width size="lg"
                      :disabled="onLoading" @click="submitChangePassword">
                      <span v-if="onLoading">
                        <i class="fas fa-spinner fa-spin"></i>&nbsp;Please wait
                      </span>
                      <span v-else>Change Password</span>
                    </argon-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import baseApiUrl from "@/configs/config";
import authService from "@/services/authService";

const body = document.getElementsByTagName("body")[0];
body.classList.remove("bg-gray-100");

export default {
  components: {
    ArgonButton,
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      showPassword: false,
      showConfirmPassword: false,
      apiUrl: baseApiUrl.storageUrl,
      errorMessage: {
        password: "",
        confirmPassword: "",
      },
      onLoading: false,
    };
  },
  computed: {
    policy() {
      return {
        minLength: this.password.length >= 8,
        hasUppercase: /[A-Z]/.test(this.password),
        hasLowercase: /[a-z]/.test(this.password),
        hasNumber: /[0-9]/.test(this.password),
        hasSymbol: /[^A-Za-z0-9]/.test(this.password),
      };
    },
    isPolicyValid() {
      const p = this.policy;
      return p.minLength && p.hasUppercase && p.hasLowercase && p.hasNumber && p.hasSymbol;
    },
  },
  mounted() {
    this.$store.commit("argonConfig/toggleDefaultLayout");

    // Jika tidak ada token, redirect ke login
    const authenticated = this.$store?.state?.auth?.authenticated || localStorage.getItem('userAuth');
    if (!authenticated) {
      window.location = '/login';
    }
  },
  methods: {
    async submitChangePassword() {
      this.errorMessage = { password: "", confirmPassword: "" };

      if (this.password.trim() === "") {
        this.errorMessage.password = "Password is required";
        return;
      }

      if (!this.isPolicyValid) {
        this.errorMessage.password = "Password does not meet all requirements";
        return;
      }

      if (this.confirmPassword.trim() === "") {
        this.errorMessage.confirmPassword = "Please confirm your password";
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.errorMessage.confirmPassword = "Passwords do not match";
        return;
      }

      this.onLoading = true;

      try {
        await authService.forceChangePassword({
          password: this.password,
          password_confirmation: this.confirmPassword,
        });

        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: "Password has been changed successfully.",
          life: 3000,
        });

        // Redirect ke my task setelah berhasil
        window.location = "/material-management/dashboards/my-task";
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: error.response?.data?.message,
          life: 5000,
        });
      } finally {
        this.onLoading = false;
      }
    },
  },
};
</script>
